import React, { JSX, useState } from 'react';
import { ScheduleType } from '../../types/schedule.types';
import {
    Card,
    Typography,
    Box,
    Stack,
    MenuItem,
    Select,
    SelectChangeEvent,


} from '@mui/material';
import ScheduleEditBlockModal from './scheduleEditBlockModal';
import ScheduleCreateBlockModal from './scheduleCreateBlockModal';
import BlankBlock from './BlankBlock';
import { ScheduleService } from "../../services/schedule.service";



interface ScheduleDisplayProps {
    schedule: ScheduleType.Model;
}

const daysOfWeek = ['MON', 'TUES', 'WED', 'THURS', 'FRI', 'SAT', 'SUN'];
const hours = Array.from({ length: 24 }, (_, i) => i);
const usTimezones = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles'];
const usTimeZonesReadable: { [key: string]: string } = {}
usTimeZonesReadable["America/New_York"] = 'Eastern Time'
usTimeZonesReadable['America/Chicago'] = 'Central Time'
usTimeZonesReadable['America/Denver'] = 'Mountain Time'
usTimeZonesReadable['America/Los_Angeles'] = 'Pacific Time'




const ScheduleDisplay: React.FC<ScheduleDisplayProps> = ({ schedule }) => {
    const screenHeight = window.innerHeight * .8
    const blockHeight = screenHeight / 24
    const [selectedTimezone, setSelectedTimezone] = useState(usTimezones.includes(schedule.timezone) ? schedule.timezone : 'America/New_York');
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [selectedBlock, setSelectedBlock] = useState<any>(null);
    const [createBlock, setCreateBlock] = useState<any>(null);

    const [error, setError] = useState<string | null>(null);

    const handleTimezoneChange = (event: SelectChangeEvent<string>) => {
        const newTimezone = event.target.value;
        setSelectedTimezone(newTimezone);
        const newSchedule: ScheduleType.Model = structuredClone(schedule);
        console.log('new timezone', newTimezone)
        newSchedule.timezone = newTimezone
        console.log('new schedule before save', newSchedule)
        ScheduleService.updateSchedule(newSchedule,
            (isValid, msg) => {
                console.log('isValid', isValid)
            }
        );
    };

    const handleOpenEditBlock = (block: any) => {
        if (block.contacts.length < 2) {
            const newContacts = [...block.contacts]
            if (newContacts.length === 0) {
                newContacts.push({ first_name: '', phone_number: '+1' })
                newContacts.push({ first_name: '', phone_number: '+1' })
            } else {
                newContacts.push({ first_name: '', phone_number: '+1' })

            }
            block = { ...block, contacts: newContacts }
        }
        setSelectedBlock(block);
        setError(null);
        setOpenEditModal(true);
    };

    const handleOpenCreateBlock = (block: any) => {
        setCreateBlock(block);
        setOpenCreateModal(true);
    };

    const handleCloseCreateModal = () => {
        setOpenCreateModal(false);
        setCreateBlock(null);
    }

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
        setSelectedBlock(null);
        setError(null);
    }

    const isOverlap = (newBlock: any, isCreate: boolean) => {
        return schedule.optimizedBlocks.some(block => {
            return (
                isCreate ? false : block.id !== selectedBlock.id &&
                    block.dayOfWeek === newBlock.dayOfWeek &&
                    ((newBlock.startHour >= block.startHour && newBlock.startHour < block.endHour) ||
                        (newBlock.endHour > block.startHour && newBlock.endHour <= block.endHour) ||
                        (newBlock.startHour < block.startHour && newBlock.endHour > block.endHour))
            );
        });
    }

    const handleSaveChanges = () => {
        if (!selectedBlock) return;
        if (isOverlap(selectedBlock, false)) {
            setError('The selected time slot overlaps with another block. Please choose a different time.');
            return;
        }
        if (selectedBlock.startHour + 1 > selectedBlock.endHour) {
            setError('The end hour needs to be at least 1 hour after the start hour');
            return;
        }

        // Here you might update the schedule state or make an API call
        console.log('Save Changes', selectedBlock);

        const newSchedule: ScheduleType.Model = structuredClone(schedule);
        console.log(JSON.stringify(schedule.optimizedBlocks));
        newSchedule.optimizedBlocks = newSchedule.optimizedBlocks.map((block) => block.id === selectedBlock.id ? ({
            ...selectedBlock,
            id: `${selectedBlock.dayOfWeek}-${selectedBlock.startHour}-${selectedBlock.endHour}`,
        }) : block)
        console.log(JSON.stringify(newSchedule.optimizedBlocks));

        ScheduleService.updateSchedule(newSchedule,
            (isValid, msg) => {
                console.log('isValid', isValid)
                if (isValid)
                    handleCloseEditModal()
            }
        );
    };

    const handleDeleteBlock = () => {
        if (!selectedBlock) return;
        // Here you might update the schedule state or make an API call
        console.log('delete block', selectedBlock);

        const newSchedule: ScheduleType.Model = structuredClone(schedule);
        newSchedule.optimizedBlocks = newSchedule.optimizedBlocks.filter((block) => block.id !== selectedBlock.id)
        ScheduleService.updateSchedule(newSchedule,
            (isValid, msg) => {
                console.log('isValid', isValid)
                if (isValid)
                    handleCloseEditModal()
            }
        );
    };

    const handleCreateBlock = () => {
        console.log('here')
        console.log(createBlock)
        if (!createBlock) return;
        if (isOverlap(createBlock, true)) {
            console.log('overlap error')

            setError('The selected time slot overlaps with another block. Please choose a different time.');
            return;
        }
        if (createBlock.startHour + 1 > createBlock.endHour) {
            console.log('hours error')
            setError('The end hour needs to be at least 1 hour after the start hour');
            return;
        }

        console.log('create block', createBlock);
        const newSchedule: ScheduleType.Model = structuredClone(schedule);
        console.log('old blocks', JSON.stringify(schedule.optimizedBlocks));
        newSchedule.optimizedBlocks.push(createBlock)
        console.log('new blocks', JSON.stringify(newSchedule.optimizedBlocks));
        ScheduleService.updateSchedule(newSchedule,
            (isValid, msg) => {
                console.log('isValid', isValid)
                if (isValid)
                    handleCloseCreateModal()
            }
        );
    };

    const formatTime = (hour: number) => {
        const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const period = (hour < 12 || hour == 24) ? "AM" : "PM";
        return `${formattedHour}:00 ${period}`;
    };

    const formatHour = (hour: number) => {
        const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const period = (hour < 12 || hour == 24) ? "AM" : "PM";
        return `${formattedHour}${period}`;
    };


    const renderTimeBlock = (dayIndex: number) => {
        const timeBlocks = schedule.optimizedBlocks
            .filter(block => block.dayOfWeek === dayIndex)
            .sort((a, b) => a.startHour - b.startHour);
        let prevBlock: any | undefined
        if (timeBlocks.length == 0) {
            return (<BlankBlock
                key={`${dayIndex}-blank-full`}
                blockHeight={blockHeight}
                startHour={0}
                endHour={24}
                onClick={() => {
                    const newBlock = {
                        id: `${dayIndex}-${0}-${24}`,
                        dayOfWeek: dayIndex,
                        startHour: 0,
                        endHour: 24,
                        contacts: [
                            {
                                full_name: '',
                                phone_number: '+1',
                            },
                            {
                                full_name: '',
                                phone_number: '+1',
                            },
                        ],
                    }
                    console.log('newBlock', newBlock)
                    handleOpenCreateBlock(newBlock);
                }}
            />)
        }
        return timeBlocks.reduce<JSX.Element[]>((prev, block, i) => {
            // if open space before first block
            if (i == 0 && block.startHour !== 0 && !prevBlock) {
                prev.push(
                    <BlankBlock
                        key={`${i}-blank-before`}
                        blockHeight={blockHeight}
                        startHour={0}
                        endHour={block.startHour}
                        onClick={() => {
                            const newBlock = {
                                id: `${dayIndex}-${0}-${block.startHour}`,
                                dayOfWeek: dayIndex,
                                startHour: 0,
                                endHour: block.startHour,
                                contacts: [
                                    {
                                        full_name: '',
                                        phone_number: '+1',
                                    },
                                    {
                                        full_name: '',
                                        phone_number: '+1',
                                    },
                                ],
                            }
                            console.log('newBlock', newBlock)
                            handleOpenCreateBlock(newBlock);
                        }}
                    />
                )
            }

            if (prevBlock !== undefined && prevBlock.endHour != block.startHour) {
                const onClick = (p: any, c: any) => () => {
                    const newBlock = {
                        id: `${c.dayOfWeek}-${p.endHour}-${c.startHour}`,
                        dayOfWeek: c.dayOfWeek,
                        startHour: p.endHour,
                        endHour: c.startHour,
                        contacts: [
                            {
                                full_name: '',
                                phone_number: '+1',
                            },
                            {
                                full_name: '',
                                phone_number: '+1',
                            },
                        ],
                    }
                    console.log('newBlock', newBlock)
                    handleOpenCreateBlock(newBlock);
                }
                prev.push(
                    <BlankBlock
                        key={`${i}-blank-between`}
                        blockHeight={blockHeight}
                        startHour={prevBlock.endHour}
                        endHour={block.startHour}
                        onClick={onClick(prevBlock, block)}
                    />
                )
            }
            prev.push(
                <Box
                    key={i}
                    onClick={() => handleOpenEditBlock(block)}
                    sx={{
                        position: 'absolute',
                        top: `${block.startHour * blockHeight}px`,
                        height: `${(block.endHour - block.startHour) * blockHeight}px`,
                        left: 0,
                        right: 0,
                        zIndex: 1,
                        paddingTop: '3px',
                        paddingBottom: '3px',
                        paddingLeft: '1%',
                        width: '100%',

                    }}>
                    <Box
                        sx={{
                            backgroundColor: '#386DA1',
                            position: 'absolute',
                            height: `${(block.endHour - block.startHour) * blockHeight - 6}px`,
                            borderRadius: 1,
                            paddingTop: 2,
                            paddingLeft: 1,
                            paddingRight: 1,
                            zIndex: 1,
                            width: '98%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'top',
                            textAlign: 'center',
                            cursor: 'pointer',
                            transition: 'border 0.2s ease-in-out', // Smooth transition effect
                            border: '2px solid transparent', // Default border (hidden)
                            '&:hover': {
                                border: '4px solid black', // Outline on hover
                                backgroundColor: '#5A8EC7', // Even lighter shade on hover
                            },
                        }}
                    >
                        <Typography variant="body2" sx={{ color: '#ffffff' }}>
                            {formatTime(block.startHour)} - {formatTime(block.endHour)}
                        </Typography>
                        <Typography sx={{ color: '#ffffff', fontWeight: 'bold', fontSize: 10 }}>
                            Emergency Contacts
                        </Typography>
                        {block.contacts.map(contact => (
                            <Typography variant="body2" key={contact.phone_number} sx={{ color: '#ffffff' }}>
                                {contact.full_name}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            );

            // if open space after last block
            if (i + 1 >= timeBlocks.length && block.endHour < 24) {
                prev.push(
                    <BlankBlock
                        key={`${i}-blank-after`}
                        blockHeight={blockHeight}
                        startHour={block.endHour}
                        endHour={24}
                        onClick={() => {
                            const newBlock = {
                                id: `${dayIndex}-${block.endHour}-${24}`,
                                dayOfWeek: dayIndex,
                                startHour: block.endHour,
                                endHour: 24,
                                contacts: [
                                    {
                                        full_name: '',
                                        phone_number: '+1',
                                    },
                                    {
                                        full_name: '',
                                        phone_number: '+1',
                                    },
                                ],
                            }
                            console.log('newBlock', newBlock)
                            handleOpenCreateBlock(newBlock);
                        }}
                    />
                )
            }
            prevBlock = block
            return prev;
        }, []);
        // return boxBlocks
    };

    return (
        <Card sx={{ p: 2, overflowX: 'auto', overflowY: 'auto', maxHeight: '70%', height: 'auto' }}>
            <Typography variant="h5" gutterBottom>
                Schedule for {schedule.team?.name ?? 'N/A'}
            </Typography>
            <Box sx={{
                mb: 2,
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center'
            }}>
                <Stack
                    direction='row'
                    spacing={2}
                    alignItems='center'
                >
                    <Typography variant="body1" gutterBottom>
                        Timezone:
                    </Typography>
                    <Select
                        value={selectedTimezone}
                        onChange={handleTimezoneChange}
                        sx={{ minWidth: 200 }}
                    >
                        {usTimezones.map((timezone) => (
                            <MenuItem key={timezone} value={timezone}>{usTimeZonesReadable[timezone]}</MenuItem>
                        ))}
                    </Select>
                </Stack>
            </Box>
            <ScheduleEditBlockModal
                openModal={openEditModal}
                error={error}
                setError={setError}
                handleCloseModal={handleCloseEditModal}
                selectedBlock={selectedBlock}
                setSelectedBlock={setSelectedBlock}
                handleSaveChanges={handleSaveChanges}
                handleDeleteBlock={handleDeleteBlock}
            ></ScheduleEditBlockModal>

            <ScheduleCreateBlockModal
                selectedBlock={createBlock}
                handleCloseModal={handleCloseCreateModal}
                handleSaveChanges={handleCreateBlock}
                openModal={openCreateModal}
                setSelectedBlock={setCreateBlock}
                error={error}
                setError={setError}
            />


            <Stack direction="row">
                <Box sx={{ width: '5%', textAlign: 'center', fontWeight: '500', paddingY: '0px', font: 'Poppins', fontSize: 20 }}>
                    TIME
                </Box>
                {daysOfWeek.map((day, index) => (
                    <Box key={index} sx={{ flex: 1, borderLeft: '1px solid #ddd', textAlign: 'center', font: 'Poppins', fontWeight: '500', fontSize: 20 }}>
                        {day}
                    </Box>
                ))}
            </Stack>


            <Stack direction="row" sx={{ overflowX: 'auto', borderTop: '1px solid #ddd' }}>

                <Box sx={{ width: '5%', height: 'auto', position: 'relative' }}>
                    {hours.map((hour) =>
                        (hour % 2 || hour === 0) ? (
                            hour === 0 ?
                                <Box key={hour} sx={{
                                    height: `${blockHeight}px`,
                                    textAlign: 'center',
                                    marginLeft: '90%',
                                    width: "auto",
                                }} />
                                :
                                <Box key={hour} sx={{
                                    height: `${blockHeight}px`,
                                    textAlign: 'center',
                                    marginLeft: '90%',
                                    width: "auto",
                                    borderTop: '1px solid #ddd',
                                    backgroundColor: "white"
                                }} />
                        ) : (
                            <Box
                                key={hour}
                                sx={{
                                    height: `${blockHeight}px`,
                                    borderTop: '1px solid #ddd',
                                    position: 'relative',
                                    marginLeft: '80%',
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        transform: 'translate(-120%, -50%)', // Move up to align with border
                                        color: '#CDCDCD',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        textAlign: "start",
                                        width: '30px',
                                        // backgroundColor: 'green',
                                    }}
                                >
                                    {formatHour(hour)}                                </Box>
                            </Box>
                        )
                    )}
                    <Box sx={{ textAlign: 'center', borderTop: '1px solid #ddd', color: '#CDCDCD', fontSize: '12px' }}>
                    </Box>
                </Box>

                {daysOfWeek.map((_, index) => (
                    <Box key={index} sx={{
                        flex: 1,
                        position: 'relative',
                        height: 'auto',
                        // backgroundColor: 'red',
                        borderLeft: '1px solid #ddd'
                    }}>
                        {renderTimeBlock(index + 1,)}
                    </Box>
                ))}
            </Stack>
        </Card>
    );
};

export default ScheduleDisplay;
